<template>
  <Modal title="Editar Actividad" @close="emitClose" size="xl">
    <form @submit.prevent="updateActivity">
      <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">

        <div class="mt-3 col-span-4 sm:col-span-4">
          <label>Nombre:</label>
          <input type="text" class="input w-full border mt-2 flex-1" v-model="activity.name" required>
        </div>

        <div class="mt-3 col-span-4 sm:col-span-4">
          <label>Imagen <span class="text-blue-700">(460px x 400px, 1MB Max)</span>:<br/>
            <a v-if="current_activity.image != null"
              class="text-blue-600 underline"
              :href="current_activity.image"
              target="_blank">ver actual</a>
          </label>
          <input type="file" class="hidden" id="file" @change="onFileChange" accept="image/png, image/jpeg, image/jpg, image/gif, image/svg">
          <div class="flex mt-2 my-auto w-full">
            <input type="text"
              class="input w-2/3 border hidden"
              v-model="activity.image_path"
              required
              disabled
              v-if="current_activity.image">
            <label for="file" class="button bg-theme-10 text-white button-sm">
              <i class="fa fa-plus"></i> Cargar Imagen
            </label>
          </div>
        </div>

        <div class="col-span-4 sm:col-span-4">
          <label>Descripción:</label>
          <textarea class="input w-full border mt-2 flex-1" v-model="activity.description" required></textarea>
        </div>

        <div class="mt-3 col-span-4 sm:col-span-4">
          <label>Fecha inicio</label>
          <input type="date" class="input w-full border mt-2" v-model="activity.start_date" required>
        </div>

        <div class="mt-3 col-span-4 sm:col-span-4">
          <label>Fecha final</label>
          <input type="date" class="input w-full border mt-2" v-model="activity.end_date" required>
        </div>

        <div class="mt-3 col-span-4 sm:col-span-4">
          <label>Puntos de 90% a 100% correcto</label>
          <input type="number" class="input w-full border mt-2" v-model="activity.points_high_correct" required>
        </div>

        <div class="mt-3 col-span-4 sm:col-span-4" v-if="activity.type != 'Extra'">
          <label>Puntos de 80% a 90% correcto</label>
          <input type="number" class="input w-full border mt-2" v-model="activity.points_medium_correct" required>
        </div>

        <div class="mt-3 col-span-4 sm:col-span-4"  v-if="activity.type != 'Extra'">
          <label>Puntos de 70% a 80% correcto</label>
          <input type="number" class="input w-full border mt-2" v-model="activity.points_under_correct" required>
        </div>

        <div class="mt-3 col-span-4 sm:col-span-4">
          <label>Estado:</label>
          <select class="input w-full border mt-2 flex-1" v-model="activity.status" required>
            <option :value="1">Activa</option>
            <option :value="0">Inactiva</option>
          </select>
        </div>

        <div class="mt-3 col-span-4">
          <label>Tipo</label>
          <select class="input w-full border mt-2 flex-1" v-model="activity.type" disabled>
            <option seleted :value="null">Seleccione ...</option>
            <option v-for="activityType in activityTypes"
              :value="activityType"
              :key="`${activityType}-activityType`">
              {{activityType}}
            </option>
          </select>
        </div>
        <div class="mt-3 col-span-4 sm:col-span-4 md:col-span-4" v-if="activity.type == 'Extra'">
          <label>Tipo Contenido</label>
          <select class="input w-full border mt-2 flex-1" v-model="activity.type_content" :disabled="checked"
            >
            <option seleted :value="null">Seleccione ...</option>
            <option v-for="activityTypeContent in activityTypeContents"
              :value="activityTypeContent"
              :key="`${activityTypeContent}-activityTypeContent`">
              {{activityTypeContent}}
            </option>
          </select>
        </div>

        <div class="mt-3 col-span-6 sm:col-span-6">
          <label>Material de estudio <span class="text-blue-700">(PDF, 5MB Max)</span>:
            <a v-if="current_activity.study_information != null"
              class="text-blue-600 underline"
              :href="current_activity.study_information"
              target="_blank">ver actual</a>
          </label>
          <input type="file" class="hidden" id="study_information" @change="onStudyActivityFileChange">
          <div class="flex mt-2 my-auto w-full">
            <input type="text"
              class="input w-2/3 border hidden"
              v-model="current_activity.study_information_path"
              required
              disabled
              v-if="current_activity.study_information != 'null'">
            <label for="study_information" class="button bg-theme-10 text-white button-sm">
              <i class="fa fa-plus"></i> Cargar Material de estudio
            </label>
          </div>
        </div>
      </div>
      <div class="px-5 py-3 text-right border-t border-gray-200">
        <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1" @click="emitClose">
          Cancelar
        </button>
        <button type="submit" class="button w-20 bg-theme-1 text-white" id="edit">
          Editar
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
  import { mapActions } from 'vuex'
  import Modal from '@/components/assets/Modal/Modal'

  export default {
    props: [
      'categories',
      'teams',
      'current_activity'
    ],
    data() {
      return {
        library: {},
        activity: {},
        activityTypes: [
          'Trivia',
          'Parejas',
          'Ordenar Letras',
          'Extra'
        ],
        activityTypeContents: [
          'Url',
          'Texto',
        ],
        loadImage: false,
      }
    },
    created() {
      this.activity = JSON.parse(JSON.stringify(this.current_activity))
      console.log(this.activity)
      //const { name: image } = JSON.parse(this.activity.image)
      //console.log(JSON.parse(this.activity.image), 'this.activity.image')
      this.activity['entity'] = 'activity'
      //this.activity['image'] = image
      this.activity.id = this.current_activity.slug
    },
    methods: {
      async updateActivity() {
        this.loading = true

        try {
          const formData = new FormData()

          Object.entries(this.activity)
          .forEach(([key, value]) => {
            console.log(key, value)
            if(value !== null) {
              formData.append(key, value)
            }
          })

          console.log(formData)

          const { model } = await this.store(formData).then(() => {
            this.$emit('close')

            this.activity = this.defineActivity()
          }).catch((error) => {
            var data = error.response.data
            if (data.errors) {
              var errors = data.errors
              console.log(errors)
              for (var item in errors) {
                for (let i = 0; i < errors[item].length; i++) {
                  window.$toast.error(errors[item][i])
                }
              }
            }
          })

        } catch (error) {
          console.log('FAILURE!!');
          console.log({ error })
        } finally {
          this.loading = false
        }
      },
      emitClose() {
        this.$emit('close')
      },
      ...mapActions([
        'store'
      ]),
      onFileChange (e) {
        this.loadImage = true
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        console.log(e.target.files[0])
        this.activity.image_path = e.target.files[0]
      },
      onStudyActivityFileChange (e) {
        this.loadImage = true
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        console.log(files)
        this.activity.study_information_path = e.target.files[0]
      },
    },
    components: {
      Modal
    }
  }
</script>



// WEBPACK FOOTER //
// ModalEditActivity.vue?722d890b